const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2019 - 2023",
    title: "Bachelor of Technology (B.Tech) - CSE",
    company: "SRM University AP",
    desc: "CGPA: - 8.78",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2017 - 2019",
    title: "Senior Secondary Education - CBSE",
    company: "Sri Viswasanthi EM High School",
    desc: "Percentage: - 87.2",
  },
  {
    id: 3,
    category: "education",
    icon: "icon-graduation",
    year: "2016 - 2017",
    title: "Secondary School Certificate - CBSE",
    company: "Pooja International School",
    desc: "CGPA: - 10/10",
  },
  {
    id: 6,
    category: "experience",
    icon: "icon-briefcase",
    year: "Jan 2026 - Present",
    title: "Engineer, Site Reliability",
    company: "TMUS Global Solutions (T-Mobile)",
    location: "Hyderabad, India",
    desc: "Building SRE observability and SLO tooling, and driving production release readiness and performance testing for enterprise document platforms.",
    responsibilities: [
      "Built a 14-module SRE observability platform (React, Node.js, MySQL) unifying Kubernetes health, API-gateway traffic, deployments, and Splunk alerting into one console",
      "Designed an SLO management system with burn-rate tracking and incident-to-SLO-breach correlation across Tier 1/2/3 services",
      "Unified on-call rosters, escalation schedules, and per-service SLA attainment history in one platform",
      "Drove production release readiness, including Microsoft Entra ID whitelisting for PROD, and led release-pipeline review across 50+ change requests",
      "Ran proactive ECM health monitoring with hourly and 4-hour Grafana/Splunk reports, tracking ingestion of ~7M documents/day",
      "Led NPI production performance testing at 1x and 3x peak load, sustaining 236 TPS ingestion and 47 TPS retrieval with 100% SLA pass",
      "Managed credential rotation for production service accounts, including Microsoft Entra ID certificates"
    ],
    technologies: ["Kubernetes", "Splunk", "Grafana", "Microsoft Entra ID", "React", "Node.js", "MySQL"],
    achievements: {
      modules: "14",
      documentsPerDay: "7M",
      ingestionTPS: "236",
      changeRequests: "50+"
    }
  },
  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "Jul 2023 - Jan 2026",
    title: "Software Engineer - II (DevOps Engineer)",
    company: "Bajaj Finserv Direct Limited",
    location: "Pune, India",
    desc: "Owned AWS infrastructure, CI/CD, and observability for enterprise-scale e-commerce platforms across Dev, QA, and Production.",
    responsibilities: [
      "Achieved a 40% ($29K) cost reduction by analyzing CPU utilization and optimizing AWS instance types",
      "Designed and automated CI/CD pipelines (Jenkins, GitLab) with build, scan, multi-environment promotion and rollback, cutting manual release effort 90%",
      "Owned provisioning, networking (VPC/subnets/security groups), and security hardening on AWS (EC2, S3, RDS, ELB, ECS, Lambda, Route53)",
      "Automated containerized Kubernetes deployments via Jenkins, integrating Docker with Terraform- and Ansible-provisioned infrastructure",
      "Built monitoring, alerting, and logging with Prometheus, Grafana, ELK, CloudWatch and CloudTrail",
      "Reduced mean incident response time 35% by improving monitoring, alerting, and on-call runbooks",
      "Automated Python/Boto3 data pipelines (S3 → MySQL/MariaDB) with 99.9% accuracy and 60% faster processing"
    ],
    technologies: ["AWS", "Docker", "Kubernetes", "Jenkins", "GitLab", "Terraform", "Ansible", "Prometheus", "Grafana", "ELK", "Python"],
    achievements: {
      costReduction: "40% ($29K)",
      releaseEffort: "90% less",
      incidentResponse: "35% faster",
      accuracy: "99.9%"
    }
  },
  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "Jan 2023 - Jun 2023",
    title: "Byte Intern",
    company: "Bajaj Finserv",
    location: "Pune, India",
    desc: "Contributed to the development and deployment of Commerce Project, gaining hands-on experience in DevOps practices and cloud technologies.",
    responsibilities: [
      "Assisted in building CI/CD pipelines for microservices deployment",
      "Participated in infrastructure setup and configuration using AWS services",
      "Developed automation scripts for routine DevOps tasks",
      "Collaborated with senior engineers on deployment strategies and best practices",
      "Learned and implemented containerization using Docker",
      "Supported production deployments and troubleshooting activities"
    ],
    technologies: ["AWS", "Docker", "Jenkins", "Git", "Linux", "Python", "Bash"],
    achievements: {
      projects: "3+",
      deployments: "20+",
      automation: "5 scripts"
    }
  },
];

export default Data;
